<div class="seg seg-detalle">
  <app-breadcrumb
    listado="/main/luminarias/seguimiento/perfiles"
    etiquetaListado="Seguimiento"
    [titulo]="titulo()"
  ></app-breadcrumb>

  <div class="seg-cabecera">
    <div class="seg-cabecera__identidad">
      <h1>
        <mat-icon>{{ motivo()?.icono ?? 'history' }}</mat-icon>
        {{ titulo() ?? 'Aplicación de perfil' }}
      </h1>
      <p class="seg-bajada">
        @if (total()) {
          <span class="seg-chip" [style.--tono]="estado().tono">
            <mat-icon>{{ estado().icono }}</mat-icon>
            {{ estado().titulo }}
          </span>
        }
        @if (aplicacion(); as a) {
          @if (motivo(); as m) {
            <span class="seg-origen" [matTooltip]="m.detalle">
              {{ m.etiqueta }}
            </span>
            <span>·</span>
          }
          @if (fuente(); as f) {
            @if (rutaFuente(); as r) {
              <a class="irx-enlace" [routerLink]="r">{{ f }}</a>
            } @else {
              <span>{{ f }}</span>
            }
            <span>·</span>
          }
          <span>
            {{ total() | number }}
            {{ total() === 1 ? 'luminaria' : 'luminarias' }}
          </span>
          <span>·</span>
          @if (quien(); as q) {
            <span>{{ q }}</span>
          } @else {
            <span>automática</span>
          }
        }
      </p>
    </div>
    <div class="seg-cabecera__acciones">
      @if (total()) {
        <button
          irxBoton="secundario"
          type="button"
          (click)="descargarInforme()"
          [disabled]="generandoInforme() || !informeListo()"
          [attr.aria-busy]="generandoInforme()"
          tooltip="Arma un PDF con todo el seguimiento de esta aplicación, con la lista completa de las que faltan."
        >
          <mat-icon>picture_as_pdf</mat-icon>
          {{ generandoInforme() ? 'Armando el informe…' : 'Informe PDF' }}
        </button>
      }
      <button
        irxBoton="secundario"
        type="button"
        (click)="recargar()"
        [disabled]="deseadas.isLoading()"
      >
        <mat-icon>refresh</mat-icon>
        Actualizar
      </button>
    </div>
  </div>

  <div class="seg-contenido">
    @if (deseadas.isLoading() && !deseadas.hasValue()) {
      <div class="seg-vacio" role="status">
        <mat-icon>hourglass_empty</mat-icon>
        <p>Buscando las luminarias de esta aplicación…</p>
      </div>
    } @else if (deseadas.error()) {
      <div class="seg-vacio seg-vacio--error" role="alert">
        <mat-icon>error_outline</mat-icon>
        <p>No se pudieron traer las luminarias.</p>
      </div>
    } @else if (!total()) {
      <div class="seg-vacio">
        <mat-icon>search_off</mat-icon>
        <p><strong>Ninguna luminaria sigue en esta aplicación</strong></p>
        <p>
          Si otra acción posterior les cambió el perfil, las luminarias pasan a
          contarse allá. Las configuraciones pendientes de antes del seguimiento
          desaparecen de acá a medida que se aplican.
        </p>
      </div>
    } @else {
      <div class="seg-portada">
        <!-- Estado: cuántas tienen el perfil, con el desglose de las que faltan. -->
        <section class="seg-tarjeta seg-estado" [style.--tono]="estado().tono">
          <div class="seg-estado__cabeza">
            <span class="seg-estado__icono">
              <mat-icon>{{ estado().icono }}</mat-icon>
            </span>
            <div>
              <span class="seg-sobretitulo">{{ estado().titulo }}</span>
              <h2
                matTooltip="Luminarias cuyo nodo ya tiene la configuración que pide el perfil, sobre las que tocó esta acción."
              >
                {{ porcentaje() }} % con el perfil
              </h2>
              <p class="seg-estado__motivo">
                {{ aplicadas() | number }} de {{ total() | number }}
                {{ total() === 1 ? 'luminaria' : 'luminarias' }}
              </p>
            </div>
          </div>

          <div
            class="seg-barra-avance seg-barra-avance--grande"
            role="img"
            [attr.aria-label]="porcentaje() + ' por ciento con el perfil'"
          >
            @for (s of segmentos(); track s.clave) {
              <span
                [style.width.%]="s.ancho"
                [style.background]="s.tono"
              ></span>
            }
          </div>
          <ul class="seg-leyenda">
            @for (s of segmentos(); track s.clave) {
              <li>
                <span class="seg-punto" [style.background]="s.tono"></span>
                <strong>{{ s.valor | number }}</strong>
                {{ s.etiqueta }}
              </li>
            }
          </ul>

          <dl class="seg-kpis-mini">
            @if (aplicacion(); as a) {
              <div class="seg-kpi" matTooltip="Cuándo se hizo la acción.">
                <dt>
                  <mat-icon>play_arrow</mat-icon>
                  Arrancó
                </dt>
                <dd>{{ fecha(a.fecha) }}</dd>
                <span class="seg-hace">{{ cuando(a.fecha) }}</span>
              </div>
              <div
                class="seg-kpi"
                [matTooltip]="
                  faltan().length
                    ? 'Desde que se hizo la acción hasta ahora.'
                    : 'Desde que se hizo la acción hasta que la última luminaria quedó con el perfil.'
                "
              >
                <dt>
                  <mat-icon>timer</mat-icon>
                  {{ faltan().length ? 'Lleva' : 'Tardó' }}
                </dt>
                @if (lleva(); as l) {
                  <dd>{{ l }}</dd>
                } @else {
                  <dd class="no-info">Sin dato</dd>
                }
              </div>
            }
            <div
              class="seg-kpi"
              [class.seg-kpi--destacado]="aRevisar()"
              matTooltip="Las detenidas y las que confirmaron y no aplicaron: piden que alguien mire el nodo."
            >
              <dt>
                <mat-icon>flag</mat-icon>
                A revisar
              </dt>
              <dd>{{ aRevisar() | number }}</dd>
            </div>
            <div
              class="seg-kpi"
              [matTooltip]="MOTIVOS_FALTA['sin-comunicacion'].detalle"
            >
              <dt>
                <mat-icon>cloud_off</mat-icon>
                Sin comunicación
              </dt>
              <dd>{{ sinComunicacion() | number }}</dd>
            </div>
          </dl>
        </section>

        <!-- La curva: cómo fueron quedando con el perfil. -->
        @if (grafico(); as g) {
          <app-chart-card
            title="Cómo fue llegando"
            icon="show_chart"
            color="blue"
            chartHeight="300px"
            [chartOptions]="g"
          >
            <mat-icon
              card-header-actions
              class="seg-ayuda"
              matTooltip="Luminarias con el perfil puesto, desde que se hizo la acción. Las líneas marcan cuándo llegó el 50 % y el 90 %. Arrastrá sobre el gráfico para ampliar un tramo."
            >
              help_outline
            </mat-icon>
          </app-chart-card>
        } @else {
          <section class="seg-tarjeta">
            <header class="seg-tarjeta__titulo">
              <mat-icon>show_chart</mat-icon>
              <h2>Cómo fue llegando</h2>
            </header>
            <p class="seg-nota">
              Las configuraciones de antes del seguimiento no tienen fecha de
              inicio: no hay curva que dibujar.
            </p>
          </section>
        }
      </div>

      @if (hitos().length) {
        <!-- Cuánto tardó en llegar cada porción de las luminarias. -->
        <section class="seg-tarjeta">
          <header class="seg-tarjeta__titulo">
            <mat-icon>timer</mat-icon>
            <h2>Cuánto tardó en converger</h2>
          </header>
          <p class="seg-nota">
            Tiempo desde la acción hasta que cada porcentaje del total de
            luminarias quedó con el perfil. Las que no comunican también cuentan
            en el total: si son muchas, los últimos hitos no se alcanzan.
          </p>
          <dl class="seg-hitos">
            @for (h of hitos(); track h.porcentaje) {
              <div class="seg-kpi" [matTooltip]="h.ayuda">
                <dt>
                  {{ h.porcentaje === 100 ? 'Todas' : h.porcentaje + ' %' }}
                </dt>
                @if (h.demoraTexto; as d) {
                  <dd>{{ d }}</dd>
                  <span class="seg-hace">{{ h.cuando }}</span>
                } @else {
                  <dd class="no-info">Todavía no</dd>
                  <span class="seg-hace">faltan {{ h.faltan | number }}</span>
                }
              </div>
            }
          </dl>
        </section>

        <div class="seg-graficos">
          @if (graficoRitmo(); as g) {
            <app-chart-card
              title="A qué ritmo llegaron"
              icon="bar_chart"
              color="blue"
              chartHeight="280px"
              [chartOptions]="g"
            >
              <mat-icon
                card-header-actions
                class="seg-ayuda"
                matTooltip="Luminarias que quedaron con el perfil en cada franja de tiempo. Los huecos son esperas: el turno del nodo en la fila de envío, el cupo del gateway o nodos que no comunican."
              >
                help_outline
              </mat-icon>
            </app-chart-card>
          } @else {
            <section class="seg-tarjeta">
              <header class="seg-tarjeta__titulo">
                <mat-icon>bar_chart</mat-icon>
                <h2>A qué ritmo llegaron</h2>
              </header>
              <p class="seg-nota">
                Ninguna luminaria quedó con el perfil todavía.
              </p>
            </section>
          }

          @if (graficoDemoras(); as g) {
            <app-chart-card
              title="Cuánto tardó cada una"
              icon="hourglass_bottom"
              color="blue"
              chartHeight="280px"
              [chartOptions]="g"
            >
              <mat-icon
                card-header-actions
                class="seg-ayuda"
                matTooltip="Luminarias según el tiempo que pasó desde la acción hasta que quedaron con el perfil. Una columna alta a la derecha indica que una parte se demoró mucho más que el resto."
              >
                help_outline
              </mat-icon>
            </app-chart-card>
          } @else {
            <section class="seg-tarjeta">
              <header class="seg-tarjeta__titulo">
                <mat-icon>hourglass_bottom</mat-icon>
                <h2>Cuánto tardó cada una</h2>
              </header>
              <p class="seg-nota">
                Ninguna luminaria quedó con el perfil todavía.
              </p>
            </section>
          }
        </div>
      }

      @if (graficoClientes(); as g) {
        <app-chart-card
          title="Por cliente"
          icon="business"
          color="blue"
          [chartHeight]="altoGraficoClientes()"
          [chartOptions]="g"
        >
          <mat-icon
            card-header-actions
            class="seg-ayuda"
            matTooltip="La acción tocó luminarias de varios clientes: cuántas de cada uno ya tienen el perfil y cuántas faltan."
          >
            help_outline
          </mat-icon>
        </app-chart-card>
      }

      <!-- Las que faltan. -->
      <section class="seg-tarjeta">
        <header class="seg-tarjeta__titulo">
          <mat-icon
            [style.color]="!faltan().length ? 'var(--color-green-icon)' : null"
          >
            {{ faltan().length ? 'flag' : 'task_alt' }}
          </mat-icon>
          <h2>Las que faltan</h2>
          @if (faltan().length) {
            <span class="seg-cuenta">{{ faltan().length | number }}</span>
          }
        </header>

        @if (!faltan().length) {
          <p class="seg-vacio-linea">
            <mat-icon class="seg-ok">check_circle</mat-icon>
            Ninguna: todas las luminarias ya tienen el perfil.
          </p>
        } @else {
          <div class="seg-motivos" role="group" aria-label="Filtrar por motivo">
            @for (m of porMotivo(); track m.motivo) {
              <button
                type="button"
                class="irx-chip seg-motivo"
                [style.--tono]="m.tono"
                [attr.aria-pressed]="motivoFiltro() === m.motivo"
                [tooltip]="m.detalle"
                (click)="alternarMotivo(m.motivo)"
              >
                <mat-icon>{{ m.icono }}</mat-icon>
                <strong>{{ m.cuantos | number }}</strong>
                <span>{{ m.etiqueta }}</span>
              </button>
            }
          </div>

          @if (sinComunicacionOcultos()) {
            <p class="seg-pista-sin">
              <mat-icon>cloud_off</mat-icon>
              <span>
                {{ sinComunicacionOcultos() | number }}
                @if (sinComunicacionOcultos() === 1) {
                  luminaria no comunica y no está en la tabla: el perfil le
                  llega cuando vuelva a comunicar.
                } @else {
                  luminarias no comunican y no están en la tabla: el perfil les
                  llega cuando vuelvan a comunicar.
                }
              </span>
              <button
                irxBoton="texto"
                type="button"
                (click)="verSinComunicacion.set(true)"
              >
                Mostrarlas
              </button>
            </p>
          } @else if (verSinComunicacion() && !motivoFiltro()) {
            <p class="seg-pista-sin">
              <button
                irxBoton="texto"
                type="button"
                (click)="verSinComunicacion.set(false)"
              >
                Ocultar las que no comunican
              </button>
            </p>
          }

          @if (visibles().length) {
            <div class="seg-tabla-scroll">
              <table class="seg-tabla">
                <thead>
                  <tr>
                    <th scope="col">Luminaria</th>
                    <th scope="col">Nodo</th>
                    <th scope="col">Por qué</th>
                    <th scope="col">Lo que falta</th>
                    <th scope="col">Último envío</th>
                  </tr>
                </thead>
                <tbody>
                  @for (f of visibles(); track f.cd._id) {
                    <tr>
                      <th scope="row">
                        @if (f.luminaria; as l) {
                          <a
                            class="irx-enlace"
                            [routerLink]="[
                              '/main/luminarias/luminarias/detalles',
                              l._id,
                            ]"
                          >
                            {{ l.identificacion || 'Sin identificación' }}
                          </a>
                        } @else {
                          <span class="no-info">Sin luminaria</span>
                        }
                      </th>
                      <td class="seg-mono">
                        @if (f.idDispositivo && verNodos) {
                          <a
                            class="irx-enlace"
                            [routerLink]="[
                              '/main/administracion/dispositivoslorawan/detalles',
                              f.idDispositivo,
                            ]"
                          >
                            {{ f.deveui || f.idDispositivo }}
                          </a>
                        } @else if (f.idDispositivo) {
                          {{ f.deveui || f.idDispositivo }}
                        } @else {
                          <span class="no-info">Sin nodo</span>
                        }
                      </td>
                      <td>
                        <span
                          class="seg-chip"
                          [style.--tono]="MOTIVOS_FALTA[f.motivo].tono"
                          [matTooltip]="MOTIVOS_FALTA[f.motivo].detalle"
                        >
                          <mat-icon>
                            {{ MOTIVOS_FALTA[f.motivo].icono }}
                          </mat-icon>
                          {{ MOTIVOS_FALTA[f.motivo].etiqueta }}
                        </span>
                      </td>
                      <td class="seg-detalle-texto">
                        @if (f.diferencias.desconocida) {
                          <span
                            class="seg-falta-desconocida"
                            matTooltipClass="seg-tooltip-multilinea"
                            [matTooltip]="f.diferencias.detalle"
                          >
                            <mat-icon>question_mark</mat-icon>
                            No se conoce su configuración
                          </span>
                        } @else if (f.diferencias.items.length) {
                          <ul class="seg-faltas">
                            @for (
                              i of f.diferencias.items.slice(0, 2);
                              track i
                            ) {
                              <li>{{ i }}</li>
                            }
                          </ul>
                          @if (f.diferencias.items.length > 2) {
                            <span
                              class="seg-faltas__mas"
                              tabindex="0"
                              matTooltipClass="seg-tooltip-multilinea"
                              [matTooltip]="f.diferencias.detalle"
                            >
                              +{{ f.diferencias.items.length - 2 }} más
                            </span>
                          }
                        } @else {
                          <span class="no-info">Todavía no se comparó</span>
                        }
                      </td>
                      <td>
                        @if (f.ultimo; as u) {
                          <span [matTooltip]="u.ultimoError || ''">
                            {{ u.nombre }} · {{ u.estado }}
                          </span>
                          @if (u.fechaCreacion) {
                            <span class="seg-hace">
                              · {{ cuando(u.fechaCreacion) }}
                            </span>
                          }
                        } @else {
                          <span class="no-info">Sin envíos todavía</span>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          } @else {
            <p class="seg-vacio-linea">
              <mat-icon class="seg-ok">check_circle</mat-icon>
              Nada que revisar: las que faltan son luminarias sin comunicación.
            </p>
          }

          @if (cuantosFiltrados() > visibles().length) {
            <p class="seg-nota">
              Se listan {{ visibles().length | number }} de
              {{ cuantosFiltrados() | number }}. Filtrá por motivo para ver el
              resto.
            </p>
          }
        }
      </section>
    }
  </div>
</div>
